export default function (Component) {
    Component.options.tsv = [{"label":"British Virgin Islands","value":656},{"label":"Panama","value":102},{"label":"Cyprus","value":69},{"label":"Seychelles","value":23},{"label":"Singapore","value":20}]
  }